class CalendarItem {

	constructor(el, options) {
		this.el = el;
		this.dataselector = '[data-calendar]';
		this.data = this.getData();

		this.registerHandleMouseClick = e => this.handleMouseClick(e);

		this.init();
	}

	/**
	 * get data attribute and return object
	 *
	 * @returns {JSON} Object
	 */
	getData() {
		return JSON.parse(this.el.dataset.calendar);
	}

	/**
	 * Bind events
	 */
	bindEvents() {
		this.el.addEventListener('click', this.registerHandleMouseClick);
	}

	/**
	 * Create ICS Download File
	 *
	 * @param {String} filename name of the file
	 * @param {String} data data in the ICS format
	 */
	createFile(filename, data) {
		var blob = new Blob([data], { type: 'text/calendar' });
		if (window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveBlob(blob, filename);
		}
		else {
			var elem = window.document.createElement('a');
			elem.href = window.URL.createObjectURL(blob);
			elem.download = filename;
			document.body.appendChild(elem);
			elem.click();
			document.body.removeChild(elem);
		}
	}

	/**
	 * Mouse Click handler
	 *
	 * @param {Object} e Mouse click event
	 */
	handleMouseClick(e) {
		let eventData = "BEGIN:VCALENDAR\r\nVERSION:2.0\r\nCALSCALE:GREGORIAN\r\nBEGIN:VEVENT\r\nSUMMARY:{summary}\r\nDTSTART;{date_begin}\r\nDTEND;{date_end}\r\nLOCATION:{location}\r\nDESCRIPTION:{description}\r\nSTATUS:CONFIRMED\r\nSEQUENCE:1\r\nEND:VEVENT\r\nEND:VCALENDAR",
			startdate = "TZID=Europe/Amsterdam:" + this.data.begin,
			enddate = "TZID=Europe/Amsterdam:" + (this.data.end ? this.data.end : startdate);

		eventData = eventData.replace("{summary}", this.data.subject);
		eventData = eventData.replace("{date_begin}", startdate);
		eventData = eventData.replace("{date_end}", enddate);
		eventData = eventData.replace("{location}", this.data.location);
		eventData = eventData.replace("{description}", this.data.description);
		
		this.createFile("ngf-event", eventData);
	}

	/**
	 *	initialize this module
	 */
	init() {
		this.bindEvents();
	}
}

export { CalendarItem as CalendarItem };